// HD-5: normalise API-supplied copy on display (DESIGN rev 2.1 §2.9 / anti-slop R-02): no em dashes, middle-dot
// meta strings or arrows in the UI. The API's own strings get fixed later; each one seen here is recorded so the HD-5 report
// can list it (window.__hfCopySeen in dev builds).
const seen = new Set();
export function clean(value) {
  if (typeof value !== 'string' || !/[—·→]/.test(value)) return value;
  if (process.env.NODE_ENV !== 'production' || process.env.REACT_APP_UI_SHEET === 'true') {
    if (!seen.has(value)) { seen.add(value); window.__hfCopySeen = [...seen]; }
  }
  return value
    .replace(/\s+—\s+/g, ': ')      // "Clip in no camera binding — C2584.MP4" → "…binding: C2584.MP4"
    .replace(/—/g, ', ')
    .replace(/\s+·\s+/g, ', ')     // "A · B" meta strings → "A, B"
    .replace(/·/g, ', ')
    .replace(/\s*→\s*/g, ' to ');  // HD-7 (P3): "Pasted 1 rows → 47 rows" reads as the word the arrow stands for
}
